module.exports = __webpack_public_path__ + "67469b2c29c4520c6036df4b1d198bd2.mp4";